import { Button, Css, ModalBody, ModalFooter, ModalHeader, MultiSelectField, useModal } from "@homebound/beam";
import { useState } from "react";
import { SaveReadyPlanLocationInput } from "src/generated/graphqlTypes";
import { PlanPackageCheckoutV2_LocationFragment } from "src/routes/libraries/plan-package-v2/components/CheckoutTab.generated";
import { renumberInputs } from "src/routes/libraries/plan-package-v2/components/checkout/InsideMapsRoomsTable";

type AddInsideMapsRoomsModalProps = {
  /** The plan's current checkout rooms, sorted by order. */
  rooms: PlanPackageCheckoutV2_LocationFragment[];
  /** The plan's rooms not yet shown in checkout. */
  eligibleRooms: PlanPackageCheckoutV2_LocationFragment[];
  /** How many rooms checkout can show. */
  maxRooms: number;
  saveRpls: (inputs: SaveReadyPlanLocationInput[]) => Promise<void>;
};

export function AddInsideMapsRoomsModal(props: AddInsideMapsRoomsModalProps) {
  const { rooms, eligibleRooms, maxRooms, saveRpls } = props;
  const { closeModal } = useModal();
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const disabledReason = selectedIds.isEmpty
    ? "Select at least one room"
    : selectedIds.length > maxRooms - rooms.length && `Checkout supports up to ${maxRooms} rooms`;

  async function onAdd() {
    await saveRpls([
      // Renumber the existing rooms so the new rooms can safely append after them
      ...renumberInputs(rooms),
      ...selectedIds.map((id, i) => ({ id, isInsideMapsRoom: true, insideMapsRoomOrder: rooms.length + i + 1 })),
    ]);
    closeModal();
  }

  return (
    <>
      <ModalHeader>Add Rooms to Checkout</ModalHeader>
      <ModalBody>
        <p css={Css.mb3.$}>Rooms are added from the locations selected on the Locations tab.</p>
        <MultiSelectField
          label="Rooms"
          options={eligibleRooms.map((rpl) => ({ id: rpl.id, name: rpl.location.name }))}
          values={selectedIds}
          onSelect={setSelectedIds}
        />
      </ModalBody>
      <ModalFooter>
        <Button variant="quaternary" label="Cancel" onClick={closeModal} />
        <Button label="Save" onClick={onAdd} disabled={disabledReason} />
      </ModalFooter>
    </>
  );
}
